import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; // AnimatePresence 추가
import { QUESTIONS } from '../data/questions';

const Test = ({ onAnswer, onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = (type, weight, choiceId) => {
    onAnswer(type, weight, choiceId);

    if (currentStep < QUESTIONS.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onComplete();
    }
  };

  const progress = ((currentStep + 1) / QUESTIONS.length) * 100;

  return (
    <div style={{ 
      backgroundColor: '#000D1A', // 조금 더 깊은 심해색으로 변경
      minHeight: '100vh', 
      color: 'white', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      padding: '0 20px',
      overflow: 'hidden', // 애니메이션 시 스크롤 방지
      position: 'relative'
    }}>

      {/* 1. 상단 나침반 에너지 프로그레스 바 */}
      <div style={{ position: 'absolute', top: '50px', width: '85%', maxWidth: '400px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', marginBottom: '10px', color: '#60A5FA', letterSpacing: '2px' }}>
          <motion.span animate={{ opacity: [0.5, 1, 0.5] }} transition={{ repeat: Infinity, duration: 2 }}>
            구역 탐사 중...
          </motion.span>
          <span>{currentStep + 1} / {QUESTIONS.length}</span>
        </div>
        <div style={{ height: '3px', backgroundColor: 'rgba(30, 58, 138, 0.3)', borderRadius: '10px', position: 'relative' }}>
          {/* 차오르는 에너지 바 */}
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            style={{
              height: '100%',
              background: 'linear-gradient(90deg, #1E3A8A, #60A5FA)',
              boxShadow: '0 0 10px #60A5FA',
              borderRadius: '10px',
              position: 'relative'
            }}
          >
            {/* 바 끝에 빛나는 에너지 포인트 */}
            <motion.div 
              animate={{ scale: [1, 1.5, 1], opacity: [0.7, 1, 0.7] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
              style={{
                position: 'absolute', right: -2, top: -3, width: '10px', height: '10px',
                borderRadius: '50%', backgroundColor: '#fff', boxShadow: '0 0 15px #fff'
              }}
            />
          </motion.div>
        </div>
      </div>

      {/* 2. 질문 영역 (AnimatePresence 적용: 안개 헤치기 효과) */}
      <AnimatePresence mode="wait">
        <motion.div
          key={currentStep} // 단계가 바뀔 때마다 애니메이션 재실행
          initial={{ opacity: 0, x: 15, filter: 'blur(15px)' }} // 시작할 때 안개(Blur)
          animate={{ opacity: 1, x: 0, filter: 'blur(0px)' }}   // 나타날 때 맑아짐
          exit={{ opacity: 0, x: -15, filter: 'blur(15px)' }}    // 사라질 때 다시 안개
          transition={{ duration: 0.6, ease: "easeInOut" }}
          style={{ 
            textAlign: 'center', 
            maxWidth: '500px', 
            width: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center' 
          }}
        >
          {/* 이미지 섹션 */}
          <div style={{ marginBottom: '35px', width: '100%' }}>
            <img 
              src={QUESTIONS[currentStep].img} 
              alt="Expedition" 
              style={{ 
                width: '100%', 
                maxWidth: '440px', 
                aspectRatio: '16 / 9', 
                objectFit: 'cover', 
                borderRadius: '24px',
                boxShadow: '0 20px 50px rgba(0,0,0,0.6)',
                border: '1px solid rgba(255, 255, 255, 0.05)'
              }} 
            />
          </div>

          {/* 질문 텍스트 */}
          <h2 style={{ 
            fontSize: '1.4rem', 
            fontWeight: '400', 
            marginBottom: '40px', 
            lineHeight: '1.7', 
            color: '#F3F4F6',
            wordBreak: 'keep-all'
          }}>
            {QUESTIONS[currentStep].q}
          </h2>

          {/* 답변 버튼들 */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', width: '100%' }}>
            {QUESTIONS[currentStep].a.map((answer, index) => (
              <motion.button
                key={index}
                whileHover={{ scale: 1.02, backgroundColor: 'rgba(59, 130, 246, 0.2)' }}
                whileTap={{ scale: 0.98 }}
                onClick={() => handleNext(answer.type, answer.weight, answer.choice)}
                style={{
                  padding: '22px 25px',
                  backgroundColor: 'rgba(255, 255, 255, 0.03)',
                  border: '1px solid rgba(59, 130, 246, 0.3)',
                  color: '#D1D5DB',
                  borderRadius: '16px',
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontSize: '1rem',
                  lineHeight: '1.4',
                  transition: 'border 0.3s',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <span style={{ 
                  color: '#60A5FA', 
                  marginRight: '15px', 
                  fontSize: '0.8rem', 
                  fontWeight: 'bold',
                  opacity: 0.6 
                }}>
                  0{index + 1}
                </span>
                {answer.text}
              </motion.button>
            ))}
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Test;